<template>
  <div class="hello">
    <div class="header">
      <div class="content">
        <a-space :size="32">
          <span class="home" @click="toHome">首页</span>
          <span class="li">查找订单</span>
          <span class="li">会员中心</span>
        </a-space>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderPage',
  props: {
    msg: String
  },
  methods:{
    toHome(){
        this.$router.push('/'); 
    }
  }
}
</script>

<style scoped lang="less">
.header {
  height: 60px;
  border-bottom: 1px solid #EDF2FA;
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.content {
  width: 1200px;
  display: flex;
  justify-content: right;

  span {
    line-height: 60px;
    font-size: 16px;
  }
}

.home:hover {
  color: #4096ff;
  cursor: pointer;
}
</style>
